/**
 * Replaces all non-alphanumeric letters (including those with diacriticals) with a replacement string.
 * Originally intended for creating a string suitable for inclusion in a DOM id (although it’s overly restrictive, that’s okay).
 * This allows the first character to be a digit which is not allowed at the start of an id.
 *
 * @param {string} str
 * @param {string} [replacement='-']
 * @return {string}
 * @example replaceNonAlphanumeric('eq-bank-(registered)-12-nr') --> 'eq-bank--registered--12-nr'
 */
function replaceNonAlphanumeric(str, replacement = '-') {
    return str.replace(/[^a-zA-Z0-9]/g, replacement);
}

export default replaceNonAlphanumeric;
